const actions = {
    NOTIFICATION_ON_CREATED: 'NOTIFICATION_ON_CREATED',
    NOTIFICATION_ON_READ: 'NOTIFICATION_ON_READ',
    NOTIFICATION_RESET: 'NOTIFICATION_RESET',

    NOTIFICATION_SET_AS_READ_REQUEST: 'NOTIFICATION_SET_AS_READ_REQUEST',
    NOTIFICATION_SET_AS_READ_SUCCESS: 'NOTIFICATION_SET_AS_READ_SUCCESS',
    NOTIFICATION_SET_AS_READ_ERROR: 'NOTIFICATION_SET_AS_READ_ERROR',

    NOTIFICATION_READ_REQUEST: "NOTIFICATION_READ_REQUEST",
    NOTIFICATION_READ_SUCCESS: "NOTIFICATION_READ_SUCCESS",
    NOTIFICATION_READ_ERROR: "NOTIFICATION_READ_ERROR",

    NOTIFICATION_OPEN_DROPDOWN: 'NOTIFICATION_OPEN_DROPDOWN',
    NOTIFICATION_CLOSE_DROPDOWN: 'NOTIFICATION_CLOSE_DROPDOWN',
    NOTIFICATION_OPEN_MODAL: 'NOTIFICATION_OPEN_MODAL',
    NOTIFICATION_CLOSE_MODAL: 'NOTIFICATION_CLOSE_MODAL',

    onCreatedNotification: data => ({
        type: actions.NOTIFICATION_ON_CREATED,
        notification: data.notificationData,
    }),
    onReadNotification: () => ({
        type: actions.NOTIFICATION_ON_READ,
    }),
    setAsReadNotification: () => ({
        type: actions.NOTIFICATION_SET_AS_READ_REQUEST,
    }),
    readNotification: (last_id = undefined) => ({
        type: actions.NOTIFICATION_READ_REQUEST,
        last_id,
    }),
    resetNotification: () => ({
        type: actions.NOTIFICATION_RESET,
    }),

    openDropdown: () => ({
        type: actions.NOTIFICATION_OPEN_DROPDOWN,
    }),
    closeDropdown: () => ({
        type: actions.NOTIFICATION_CLOSE_DROPDOWN,
    }),
    openModal: (notification, shouldOpenPopoverOnClose = true) => ({
        type: actions.NOTIFICATION_OPEN_MODAL,
        notification,
        shouldOpenPopoverOnClose,
    }),
    closeModal: () => ({
        type: actions.NOTIFICATION_CLOSE_MODAL,
    }),
};
export default actions;
